import useFlowDeposit from "@/web3Hook/useFlowDeposit";
import { Form, InputNumber } from "antd"
import { parseUnits } from "ethers";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import card from '@/image/card.svg'
import { hashrateData, SYMBOL } from "@/collocate";
import ButtonPrimary from "@/components/ButtonPrimary";
import BalanceCom from "@/components/BalanceCom";
import useGetTokenBalance from "@/web3Hook/useGetTokenBalance";
import useGetAllowanceToken from "@/web3Hook/useGetAllowanceToken";
import useUpdateEffect from "@/hooks/useUpdateEffect";
type FieldType = {
    pledge: number;
};
const FlowHashrate = () => {
    const { t, i18n: { language } } = useTranslation()
    const [form] = Form.useForm();
    // 算力显示
    const [hashrate, setHashrate] = useState(hashrateData[0])
    const { allowance, allowanceLod, approve, allowanceLodFun, getAllowance } = useGetAllowanceToken()
    const { tokenBalance, getTokenBalance, tokenBalanceLod } = useGetTokenBalance()
    // 质押函数
    const { flowDepositLod, flowDeposit } = useFlowDeposit()
    const pledgeNum = Form.useWatch('pledge', form) || 0;
    const isApprove = useMemo(() => {
        const pledgedPowerStr = pledgeNum ? pledgeNum + '' : '0';
        return allowance >= parseUnits(pledgedPowerStr);
    }, [allowance, pledgeNum]);
    // Form校验成功
    const onFinish = (values: any) => {
        if (!isApprove) {
            approve({
                success: t('flow.enableSuccess'),
                error: t('flow.enableFailure')
            })
        } else {
            flowDeposit(parseUnits(values.pledge + ''), {
                success: t('flow.successfulPledge'),
                error: t('flow.failureOfPledge')
            },
                () => {
                    getTokenBalance();
                    getAllowance()
                    form.resetFields();
                }
            )
        }

    };
    // 算力
    const hashrateFn = (value: number) => {
        (value < hashrateData[0].min || value > hashrateData[5].max) && setHashrate(hashrateData[0])
        value >= hashrateData[1].min && value < hashrateData[1].max && setHashrate(hashrateData[1])
        value >= hashrateData[2].min && value < hashrateData[2].max && setHashrate(hashrateData[2])
        value >= hashrateData[3].min && value < hashrateData[3].max && setHashrate(hashrateData[3])
        value >= hashrateData[4].min && value < hashrateData[4].max && setHashrate(hashrateData[4])
        value >= hashrateData[5].min && value <= hashrateData[5].max && setHashrate(hashrateData[5])
    }
    // 大于等于100小于等于3万且是100的倍数
    const mathematicalCheck = () => ({
        validator(_: any, value: number) {
            hashrateFn(value) // 这个方法会更新算力显示，状态更新后会重新渲染
            if (!value) {
                return Promise.resolve();
            } else if (value < hashrateData[0].min || value > hashrateData[0].max) {
                return Promise.reject(t('flow.fromText', { min: hashrateData[0].min, max: hashrateData[0].max }));
            } else if (value % 100 !== 0) {
                return Promise.reject(t('flow.fromText1', { num: hashrateData[0].min }));
            }
            else if (tokenBalance < parseUnits(value + '')) {
                return Promise.reject(t('flow.fromText2'));
            }
            else {
                return Promise.resolve();
            }
        },
    })
    useUpdateEffect(() => {
        form.submit()
    }, [language])
    return (
        <div className="mx-4 md:mx-6">
            <Form
                form={form}
                name="dsd1"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
            >
                <div className="bg-3c p-4 md:p-6 rounded-2xl">

                    <div className="border rounded-lg border-a4 bg-49 p-3 pb-0">
                        <div className="text-white text-xs mb-2">
                            {t('flow.stakingAmount')}
                        </div>
                        <Form.Item<FieldType>
                            name="pledge"
                            rules={[
                                {
                                    required: true,
                                    message: t('flow.fromText3')
                                },
                                mathematicalCheck(),
                            ]}
                        >
                            <InputNumber controls={false} suffix={SYMBOL} className="w-full" placeholder={t('flow.startWith100', { num: hashrateData[0].min })} />
                        </Form.Item>
                    </div>

                    <div className="flex items-center justify-between mt-5 text-white gap-3"  >
                        <div className="flex-1">
                            <div className="mb-2 text-xs md:text-sm">{t('flow.flowComputingPowerMonth')}</div>
                            <div className="border border-a4 rounded-lg h-9.5 md:h-11 flex items-center justify-center font-semibold text-sm md:text-base">{hashrate.m}</div>
                        </div>
                        <div className="flex-1">
                            <div className="mb-2 text-xs md:text-sm">{t('flow.peakComputingPowerYear')}</div>
                            <div className="border border-a4 rounded-lg h-9.5 md:h-11 flex items-center justify-center font-semibold text-sm md:text-base">{hashrate.y}</div>
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-end mt-5">
                    <img src={card} className="w-6 h-6 mr-1.5" alt="" />
                    <BalanceCom qText={t('flow.balance') + "："} className="text-sm text-d1" balance={tokenBalance} loading={tokenBalanceLod} />
                </div>
                {/* 提交按钮 */}
                <ButtonPrimary
                    className="h-11.25 mt-1.5"
                    htmlType="submit"
                    text={isApprove ? t('flow.confirm') : t('flow.enable')}
                    loading={tokenBalanceLod || allowanceLod || flowDepositLod || allowanceLodFun}
                    block
                />
            </Form>


        </div>
    )
}

export default FlowHashrate